<template>
  <v-app>
    <vertical-nav-menu :is-drawer-open.sync="isDrawerOpen"></vertical-nav-menu>
    <menu-vertical-config :is-drawer-open.sync="isDrawerOpen2"></menu-vertical-config>
    <Alert />
    <v-app-bar app flat fixed color="dark">
      <div class="boxed-container w-full">
        <div class="d-flex align-center mx-6">
          <!-- Left Content -->
          <v-app-bar-nav-icon class="d-block   me-2" @click="isDrawerOpen = !isDrawerOpen"></v-app-bar-nav-icon>
          <select-img v-if="store.state.user.arbol.find(i => i.id_puesto >= 0) && $route.name.includes('puesto')">
          </select-img>
          <v-spacer></v-spacer>
          <!-- Right Content -->
          <ind-propina
            ref="IndPropinaRef"
            v-if="!(store.state.user.arbol.find(i => i.id_puesto >= 0) && $route.name.includes('puesto'))"
          ></ind-propina>
          <PruebaConexion />

          <theme-switcher class="ms-3"></theme-switcher>
          <cambio-clave ref="CambioClaveRef" :tipoBtn="'0'"></cambio-clave>
          <AppBarNotifyMenu @GetConfirmacionUsuario="GetConfirmacionUsuario" />
          <app-bar-user-menu
            @AbrirQr="AbrirQr"
            @AbrirClave="AbrirClave"
            @AbrirPropina="AbrirPropina"
            @AbrirAvatar="AbrirAvatar"
            @AbrirConfig="AbrirConfig"
            @AbrirAutorizar="AbrirAutorizar"
          ></app-bar-user-menu>

          <ModalQrWifiVue ref="ModalQrWifiVueRef"></ModalQrWifiVue>
        </div>
      </div>
    </v-app-bar>

    <v-main>
      <div class="app-content-container boxed-container pa-6">
        <slot></slot>
      </div>
    </v-main>

    <avatar-select ref="AvatarSelectRef"></avatar-select>
    <ComporbacionUsuario ref="ComporbacionUsuarioRef" />

    <ModalConfirmarLeerQr ref="ModalConfirmarLeerQrRef" ></ModalConfirmarLeerQr>
  </v-app>
</template>

<script>
import { onBeforeMount, ref, watch } from '@vue/composition-api'
import {
  mdiMagnify,
  mdiBellOutline,
  mdiGithub,
  mdiCogOutline,
  mdiQrcode,
  mdiLanConnect,
  mdiLanDisconnect,
} from '@mdi/js'
import VerticalNavMenu from './components/vertical-nav-menu/VerticalNavMenu.vue'
import ThemeSwitcher from './components/ThemeSwitcher.vue'
import AppBarUserMenu from './components/AppBarUserMenu.vue'
import AppBarNotifyMenu from './components/AppBarNotifyMenu.vue'

import SelectImg from './components/SelectImg.vue'
import store from '@/store'
import router from '@/router'
import axios from '@/api'
import Alert from '@/layouts/Alert.vue'
import MenuVerticalConfig from './components/MenuVerticalConfig.vue'
import IndPropina from '@/views/sistema/comanda/dashboard/componentes/IndPropina.vue'
import CambioClave from '@/views/sistema/administracion/archivo/empleado/CambioClave.vue'
import MaestroService from '@/api/servicios/MaestroService'
import AvatarSelect from '@/components/AvatarSelect.vue'
import ProductosService from '@/api/servicios/ProductosService'
import ModalQrWifiVue from '@/components/ModalQrWifi.vue'
import PruebaConexion from '@/components/PruebaConexion.vue'
import { socket, state as stateSocket } from '@/plugins/sockets'
import ComporbacionUsuario from '../components/ComporbacionUsuario.vue'

import { acciones } from '@/modulos'
import ModalConfirmarLeerQr from '@/components/ModalConfirmarLeerQr.vue'
export default {
  components: {
    VerticalNavMenu,
    ThemeSwitcher,
    AppBarUserMenu,
    AppBarNotifyMenu,
    SelectImg,
    Alert,
    MenuVerticalConfig,
    IndPropina,
    CambioClave,
    AvatarSelect,
    ModalQrWifiVue,
    PruebaConexion,
    ComporbacionUsuario,
    ModalConfirmarLeerQr
  },
  setup() {
    const AvatarSelectRef = ref(null)
    const AvatarSelectNotifyRef = ref(null)
    const isDrawerOpen = ref(false)
    const isDrawerOpen2 = ref(null)
    const ModalQrWifiVueRef = ref(null)
    const ComporbacionUsuarioRef = ref(false)
    const AbrirAvatar = () => {
      AvatarSelectRef.value.abrir()
    }

    const AbrirConfig = () => {
      isDrawerOpen2.value = true
    }

    let counterConsultas = ref(0)
    /*watch(counterConsultas, () => {
      setTimeout(() => {
        CargarPuestoProductos(true)
      }, 30000)
    })*/

    onBeforeMount(() => {
      setTimeout(() => {
        CargarPuestoProductos(false)
        cargarVersion()
      }, 1000)
    })

    onBeforeMount(() => {
      socket.on('modifica-producto', (...args) => {
        CargarPuestoProductos(false)
      })
    })

    const cargarVersion = async () => {
     
        await MaestroService.versionSistemaActual({ actual: process.env.VUE_APP_VERSION })
          .then(response => {
            if (response.data.mensaje == 'ERROR') {
              
              store.commit('setUserData', { autenticate: false })
              router.push('/pages/login')
            }
          })
          .catch(error => {
            console.error(error)
          })
       
    }

    const DatosConfiguracion = () => {
      MaestroService.DatosConfiguracion()
        .then(response => {
          if (response.data.mensaje == 'BUSQUEDA_EXITOSA') {
            store.commit('setconfiguracionGeneral', response.data.datos)
          }
        })
        .catch(error => {
          console.error(error)
        })
    }
    const linkMaster = () => {
      return config.VUE_APP_URL_IMG || process.env.VUE_APP_URL_IMG
    }
    const validarAcciones = accion => {
      const valor = store.state.user.accion_modulo.includes(accion)

      return valor
    }
    const CargarPuestoProductos = actualizar => {
      if (validarAcciones(acciones.DASHBOARD_COMANDA_VER_COMANDA)) {
        ProductosService.obtenerProductosPuestos({ id_puesto: -1 })
          .then(response => {
            if (response.data.mensaje == 'BUSQUEDA_EXITOSA') {
              store.commit('setPuestoProductos', response.data.datos)
            }
          })
          .catch(error => {
            console.error(error)
          })

          .finally(dato => {
            if (actualizar == true) counterConsultas.value += 1
          })
      }
    }

    const GetConfirmacionUsuario = args => {
      if (args.usuario.toUpperCase() == store.state.user.usuario) {
        ComporbacionUsuarioRef.value.abrir(args)
      }
    }

    store.commit('setAlert', {}, { root: true })
    if (!store.state.user.IsAutenticated) {
      router.push('/pages/login')
    } else {
      if (axios.defaults.headers.common['Authorization'] == undefined) {
        console.log(axios.defaults.headers.common['Authorization'])
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.user.token

        axios
          .post('/login/iniciarSesionToken', {
            user: store.state.user.id,
            token: store.state.user.token,
          })
          .then(function (response) {
            if (response.data.mensaje == 'INICIO_SESION_EXITOSA') {
              store.commit('setUserData', { ...response.data.datos, autenticate: true })
              DatosConfiguracion()

              socket.emit('join', { usuario: store.state.user.usuario })
            } else {
              store.commit('setUserData', { autenticate: false })
              router.push('/pages/login')
            }
            console.log(response)
          })
          .catch(function (error) {
            if (error.response.status == 403) {
              store.commit('setUserData', { autenticate: false })
              router.push('/pages/login')
            }
            console.error(error)
          })
      }
    }

    const AbrirQr = () => {
      ModalQrWifiVueRef.value.abrir()
    }
    const CambioClaveRef = ref(null)
    const AbrirClave = () => {
      CambioClaveRef.value.abrir()
    }

    const IndPropinaRef = ref(null)
    const AbrirPropina = () => {
      IndPropinaRef.value.abrir()
    }
    const ModalConfirmarLeerQrRef = ref()
    const AbrirAutorizar= () => {
      
      ModalConfirmarLeerQrRef.value.abrir()
    }
    return {
      isDrawerOpen,
      isDrawerOpen2,
      AbrirConfig,
      CargarPuestoProductos,
      // Icons
      icons: {
        mdiMagnify,
        mdiBellOutline,
        mdiGithub,
        mdiCogOutline,
        mdiQrcode,
        mdiLanConnect,
        mdiLanDisconnect,
      },
      ComporbacionUsuarioRef,
      store,
      AbrirAvatar,
      AvatarSelectRef,
      ModalQrWifiVueRef,
      AbrirQr,
      linkMaster,
      AbrirClave,
      AbrirPropina,
      IndPropinaRef,
      CambioClaveRef,
      GetConfirmacionUsuario,
      ModalConfirmarLeerQrRef,
      AbrirAutorizar
    }
  },
}
</script>

<style lang="scss" scoped>
.v-app-bar ::v-deep {
  .v-toolbar__content {
    padding: 0;

    .app-bar-search {
      .v-input__slot {
        padding-left: 18px;
      }
    }
  }
}

.boxed-container { 
  margin-left: auto;
  margin-right: auto;
}
</style>
